import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WishDal } from '../dal/wish.dal';
import { Wish } from '../models/wish.model';

@Injectable({
  providedIn: 'root',
})
export class WishesService {
  constructor(private wishDal: WishDal) {}

  getWishesByProfileAndType(
    profileId: string,
    type: string,
    isIndividualJobDescription: boolean = false
  ): Observable<any[]> {
    return this.wishDal.getWishesByProfileAndType(profileId, type, isIndividualJobDescription);
  }

  getWishesByProfileAndType2(profileId: string, isIndividualJobDescription: boolean): Observable<Wish[]> {
    return this.wishDal.getWishesByProfileAndType2(profileId, isIndividualJobDescription);
  }

  getWishesByProfileAndTypeFromHospital(profileId: string, type: string, hospitalId: string): Observable<any[]> {
    return this.wishDal.getWishesByProfileAndTypeFromHospital(profileId, type, hospitalId);
  }

  editWishes(profileId: string, wishes: any[]) {
    return this.wishDal.editWishes(profileId, wishes);
  }

  deleteMany(ids: string[]) {
    return this.wishDal.deleteMany(ids);
  }

  addMany(wishes: Wish[]) {
    return this.wishDal.addMany(wishes);
  }

  updateMany(wishes: Wish[]) {
    return this.wishDal.updateMany(wishes);
  }
}
